export type CreateDocumentContextApiResponse = /** status 201  */ DocumentContextResponseBody;
export type CreateDocumentContextApiArg = {
  documentContextRequestBody: DocumentContextRequestBody;
};
export type DeleteDocumentContextApiResponse = unknown;
export type DeleteDocumentContextApiArg = {
  documentContextId: string;
};
export type GetDocumentContextCountApiResponse =
  /** status 200  */ DocumentContextCountResponseBody;
export type GetDocumentContextCountApiArg = {
  contextTarget: ContextTarget;
  contextId: string;
};
export type GetSignableDocumentsApiArg = {
  contextId: string;
  contextTarget: ContextTarget;
  contextSource?: ContextSource;
};

export type GetSignableDocumentsResponseBody = {
  fileId: string;
  name: string;
  createdBy: string;
  createdAt: string;
};
export type GetSignableDocumentsApiRes = GetSignableDocumentsResponseBody[];
export type FileType = 'pdf' | 'docx' | 'manual';
export type DocumentContextResponseBody = {
  id: string;
  fileRemoteId: string;
  fileName: string;
  fileType: FileType;
  createdAt: string;
  createdBy: string;
  note: string | null;
};
export type ContextSource = 'gdpr';
export type ContextTarget =
  | 'vehicle'
  | 'customer'
  | 'business-case'
  | 'service-case'
  | 'service-case-order'
  | 'service-order-return'
  | 'service-order-issue-note'
  | 'warehouse-supplier-order'
  | 'warehouse-receipt-note'
  | 'warehouse-credit-note'
  | 'warehouse-issue-note'
  | 'warehouse-issue-note-correction'
  | 'warehouse-article'
  | 'warehouse-delivery-note'
  | 'warehouse-fast-track'
  | 'warehouse-transfer-order'
  | 'direct-sale'
  | 'tire-order'
  | 'rental-order'
  | 'interest';
export type BulkContext = BulkContextItem[];
export type BulkContextItem = {
  target: ContextTarget;
  targetId: string;
};
export type DocumentContextRequestBody = {
  fileRemoteId: string;
  contextTarget: ContextTarget;
  contextId: string;
  fileName: string;
  note: string | null;
};
export type CreateDocumentContextBulkApiResponse = /** status 201  */ DocumentContextResponseBody;
export type CreateDocumentContextBulkApiArg = {
  documentContextBulkRequestBody: DocumentContextBulkRequestBody;
};
export type DocumentContextBulkRequestBody = {
  fileRemoteId: string;
  contextSource: ContextTarget;
  contextSourceId: string;
  fileName: string;
  note: string | null;
  contexts: {
    target: ContextTarget;
    targetId: string;
  }[];
  manual?: boolean;
};
export type DocumentContextCountResponseBody = {
  count: number;
};
